import { render, staticRenderFns } from "./Wp_share_poster.vue?vue&type=template&id=39032ad0&scoped=true&"
import script from "./Wp_share_poster.vue?vue&type=script&lang=js&"
export * from "./Wp_share_poster.vue?vue&type=script&lang=js&"
import style0 from "./Wp_share_poster.vue?vue&type=style&index=0&id=39032ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39032ad0",
  null
  
)

export default component.exports